import { call, put, takeEvery } from 'redux-saga/effects'

import api from '../../utils/api'
import * as apiErrorHelpers from '../../helpers/apiErrorHelpers'
import * as sessionHelpers from '../../helpers/sessionHelpers'

export function* changeMembership(action) {
  try {
    yield put({ type: 'SET_LOADING' })
    yield put({ type: 'UNSET_LOADING_ERROR' })

    const payload = action.payload || {}

    api.setAuthApi({
      'Authorization': sessionHelpers.getApplicationCookie('authentication_token')
    })

    yield put({ type: 'CHANGE_MEMBERSHIP_REQUESTED' })

    let request = {
      url: '/memberships',
      body: { customer_id: payload.customerId, new_membership_plan_id: payload.membershipPlanId}
    }

    let response = yield call(api.utility.post, api.path(request.url), { body: request.body })

    apiErrorHelpers.catchErrors(response.body)

    yield put({
      type: 'CHANGE_MEMBERSHIP_SUCCEEDED',
      payload: {
        activeMembership: response.body
      }
    })
    yield call(action.callback, 'success', { activeMembership: response.body })

    yield put({ type: 'UNSET_LOADING'})
  }
  catch (errors) {
    // eslint-disable-next-line
    errors = apiErrorHelpers.formatInternalErrors(errors)

    yield put({ type: 'LOADING_FAILED' })
    yield put({ type: 'SET_LOADING_ERROR' })
    yield put({ type: 'UNSET_LOADING' })

    const afterRequestData = {
      alertMessage: apiErrorHelpers.toString(errors)
    }
    yield call(action.callback, 'failure', afterRequestData)

    apiErrorHelpers.consoleLog(errors)
  }
} // changeMembership()

export default function* membershipSaga() {
  yield takeEvery('MEMBERSHIPS_UPDATE_SAGA', changeMembership)
}
